import * as React from "react";
import { Input, Button, Form, Alert } from "antd";
import { FormComponentProps } from "antd/lib/form";

const FormItem = Form.Item;

interface FormValues {
  oldPassword: string;
  newPasswordCheck?: string;
  newPassword: string;
}

export interface Props extends FormComponentProps {
  // tslint:disable-next-line:no-any
  onSubmit(values: FormValues): Promise<void | any>;
}

export interface State {
  loading: boolean;
  error: string | null;
  success: string | null;
}

class ChangePasswordForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { loading: false, error: null, success: null };
  }
  handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    this.props.form.validateFields((err, values: FormValues) => {
      if (!err) {
        if (values.newPassword !== values.newPasswordCheck) {
          this.setState({
            error: "New passwords do not match!",
            success: null
          });
          return;
        }
        this.setState({ loading: true, error: null, success: null });
        this.props
          .onSubmit(values)
          .then(() => {
            this.props.form.resetFields();
            this.setState({ loading: false, success: "Password changed!" });
          })
          .catch(r => {
            console.log(r);
            this.setState({ loading: false, error: r.toString() });
          });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        {this.state.success && (
          <Alert message={this.state.success} type="success" showIcon={true} />
        )}
        {this.state.error && (
          <Alert message={this.state.error} type="error" showIcon={true} />
        )}
        <FormItem label="Old password">
          {getFieldDecorator("oldPassword", {
            rules: [{ required: true, message: "Please input your password!" }]
          })(<Input type="password" />)}
        </FormItem>
        <FormItem label="New password">
          {getFieldDecorator("newPassword", {
            rules: [
              { required: true, message: "Please input your new password!" }
            ]
          })(<Input type="password" />)}
        </FormItem>
        <FormItem label="Confirm new password">
          {getFieldDecorator("newPasswordCheck", {
            rules: [
              {
                required: true,
                message: "Please input your new password again!"
              }
            ]
          })(<Input type="password" />)}
        </FormItem>
        <FormItem>
          <Button loading={this.state.loading} htmlType="submit" type="danger">
            Update Password
          </Button>
        </FormItem>
      </Form>
    );
  }
}
export default Form.create<Props>()(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/components/UserDetails/ChangePasswordForm/ChangePasswordForm.tsx